import { render, staticRenderFns } from "./AppDescriptionItem.vue?vue&type=template&id=cb6ccaa0"
import script from "./AppDescriptionItem.vue?vue&type=script&lang=js"
export * from "./AppDescriptionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports